import { render, staticRenderFns } from "./VSelectNationality.vue?vue&type=template&id=095a741b&"
import script from "./VSelectNationality.vue?vue&type=script&lang=js&"
export * from "./VSelectNationality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095a741b')) {
      api.createRecord('095a741b', component.options)
    } else {
      api.reload('095a741b', component.options)
    }
    module.hot.accept("./VSelectNationality.vue?vue&type=template&id=095a741b&", function () {
      api.rerender('095a741b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectNationality.vue"
export default component.exports